export default "__VITE_ASSET__B4H$q_8w__"